import { Button, Input, Modal } from 'antd';
import React from 'react';

const ContractContentsModal = ({ isOpen, closeModal, contractContents }) => {
  const { TextArea } = Input;

  const handleModalClose = () => {
    closeModal();
  };

  return (
    <Modal
      title={contractContents.name}
      style={{ top: 10 }}
      width="70%"
      onClose={handleModalClose}
      onOk={() => {}}
      onCancel={handleModalClose}
      open={isOpen}
      destroyOnClose
      data-cy="view-dataContract-modal"
      footer={[
        <Button key="close" onClick={handleModalClose}>
          Close
        </Button>,
      ]}
    >
      <TextArea
        disabled
        rows={25}
        bordered={false}
        showCount
        value={JSON.stringify(contractContents, null, 4)}
        maxLength={25000}
      />
    </Modal>
  );
};

export default ContractContentsModal;
